module.exports = __webpack_public_path__ + "img/tu10.9fc36709.jpg";